export const AssetSearchFilters = ({
  filters,
  onFiltersChange,
  onApplyFilters,
  onClearFilters,
}: any) => {
  const FIELD_CLASSES = {
    container: "w-full mb-4",
    label: "block text-sm font-semibold text-gray-700 mb-2",
    input:
      "w-full h-11 px-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all bg-gray-50",
    select:
      "w-full h-11 px-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all bg-gray-50",
    error: "text-red-600 text-sm mt-1",
    helperText: "text-xs text-gray-500 mt-1",
  } as const;

  const createFormFields = () => [
    {
      name: "assetType",
      label: "Asset Type",
      type: "select",
      required: false,
      placeholder: "All Types",
      options: [
        { label: "All Types", value: "all" },
        { label: "Pipe", value: "pipe" },
        { label: "Hydrant", value: "hydrant" },
        { label: "Valve", value: "valve" },
        { label: "Meter", value: "meter" },
        { label: "Pump", value: "pump" },
        { label: "Tank", value: "tank" },
      ],
      classes: FIELD_CLASSES,
    },
    {
      name: "facility",
      label: "Facility",
      type: "select",
      required: false,
      placeholder: "All Facilities",
      options: [
        { label: "All Facilities", value: "all" },
        { label: "Main Treatment Plant", value: "main-plant" },
        { label: "Distribution Center A", value: "dist-a" },
        { label: "Distribution Center B", value: "dist-b" },
        { label: "Pumping Station 1", value: "pump-1" },
      ],
      classes: FIELD_CLASSES,
    },
    {
      name: "system",
      label: "System",
      type: "select",
      required: false,
      placeholder: "All Systems",
      options: [
        { label: "All Systems", value: "all" },
        { label: "Primary Distribution", value: "primary" },
        { label: "Secondary Distribution", value: "secondary" },
        { label: "Service Lines", value: "service" },
        { label: "Transmission", value: "transmission" },
      ],
      classes: FIELD_CLASSES,
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      required: false,
      placeholder: "All Statuses",
      options: [
        { label: "All Statuses", value: "all" },
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "Maintenance", value: "maintenance" },
        { label: "Out of Service", value: "out-of-service" },
      ],
      classes: FIELD_CLASSES,
    },
  ];

  // Handle form submission (Apply Filters)
  const handleSubmit = (data: any) => {
    onApplyFilters({ ...data, page: 1 });
  };

  // Handle form reset (Clear Filters)
  const handleReset = () => {
    const defaultFilters: any = {
      assetType: "all",
      facility: "all",
      system: "all",
      network: "all",
      location: "",
      status: "all",
      page: 1,
    };
    onClearFilters();
  };

  // Custom footer with Apply and Clear buttons
  const renderCustomFooter = () => (
    <div className="flex justify-between items-center pt-6 border-t border-gray-200">
      <button
        type="button"
        onClick={handleReset}
        className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
      >
        <svg
          className="h-4 w-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        Clear Filters
      </button>

      <button
        type="submit"
        onClick={() => handleSubmit(filters)}
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
      >
        Apply Filters
      </button>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-4 gap-4">
        {createFormFields().map((field) => (
          <div key={field.name} className={field.classes.container}>
            <label className={field.classes.label}>{field.label}</label>
            <select
              value={filters[field.name as keyof any] as string}
              onChange={(e) =>
                onFiltersChange({
                  ...filters,
                  [field.name]: e.target.value,
                })
              }
              className={field.classes.select}
            >
              {field.options?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>



      {renderCustomFooter()}
    </div>
  );
};
